import React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { CalendarMonth as CalendarIcon } from '@mui/icons-material'
import { CalendarInputProps } from 'Common/Supplyvue-ui/CalendarInput.types'
import { StyledTextField } from 'Common/Supplyvue-ui/CalendarInput.styles'

export const CalendarInput = ({
  value,
  onChange,
  iconLabel = 'calendar icon',
  className,
  disabled = false,
  closeOnDateSelection = true,
  format = 'dd.MM.yyyy',
  ...otherProps
}: CalendarInputProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        disabled={disabled}
        inputFormat={format}
        value={value}
        onChange={onChange}
        closeOnSelect={closeOnDateSelection}
        components={{
          OpenPickerIcon: CalendarIcon,
        }}
        renderInput={(params) => (
          <StyledTextField
            {...params}
            aria-label="calendar-input"
            data-testid="calendar-input"
            className={className}
            {...otherProps}
          />
        )}
      />
    </LocalizationProvider>
  )
}
